export default __webpack_public_path__ + "static/media/Seasonal Work - Short Stay.18d7299d.jpg";